import { makeStyles } from '@mui/styles';

export const useStyles = makeStyles(() => ({
  formCardWrap: {
    margin: 'auto 0.25rem',
  },
  backgroundPages: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center'
  },
  backgroundPagesView: {
    background: 'transparent linear-gradient(180deg, #FEFEFE 0%, #ECEBEC 100%) 0% 0% no-repeat padding-box',
    height: 8,
  },
  formCardContainer: {
    minHeight: 710,
    background: 'transparent linear-gradient(180deg, #FEFEFE 0%, #E9E9E9 100%) 0% 0% no-repeat padding-box',
    boxShadow: '0px 3px 6px #00000029',
  },
}));
